import OrderPlaceIdSelect from "@/components/form/order-place-id-select";
import {
  makePickerField,
  type PickerFieldProps,
} from "@/fields/_internal/make-picker-field";

type LinkOrderFieldExtraProps = {
  /** Scopes the order list to this place. */
  placeId: string;
};

/** **Value is an order id** (`string | null`). */
export type LinkOrderFieldProps = PickerFieldProps<
  string | null,
  LinkOrderFieldExtraProps
>;

export const LinkOrderField = makePickerField<
  string | null,
  LinkOrderFieldExtraProps
>({
  name: "LinkOrderField",
  control: OrderPlaceIdSelect,
  controlProps: (props) => ({ placeId: props.placeId }),
});
